export default __webpack_public_path__ + "static/media/webiner_coach2.de920207.jpg";